






































import Vue from "vue"

export default Vue.extend({
  methods: {
    resendMail(id: number) {
      this.$http.post("/range_office/resend_range_email/" + id)
    }
  },
  props: {
    ranges: {
      required: true
    }
  }
})
